import React from "react";
import { Redirect } from "react-router-dom";
 
import adminLoginRoutes from "./views/admin-login/AdminLoginRoutes"; 
import adminManagmentRoutes from "./views/admin-management/AdminManagmentRoutes";
import userManagmentRoutes from "./views/admin-user-management/UserManagmentRoutes";
import adminDeptManagmentRoutes from "./views/admin-department-managment/AdminDeptManagmentRoutes";
import adminBlockManagmentRoutes from "./views/admin-block-email-managment/AdminBlockManagmentRoutes";
import adminSettingsRoutes from "./views/admin-settings/AdminSettingsRoutes";
import adminChatRoutes from "./views/admin-chat/ChatRoutes"; 
import inboxRoute from "./views/admin-ticket/InboxRoutes"; 
import reportsRoute from "./views/admin-reports/TicketRoutes";
import userTicketLoginRoutes from "./views/user-ticket-login/UserTicketLoginRoutes";
import adminUserChat from "./views/user-chat/UserChatRoutes";
import adminDashboardRoutes from "./views/dashboard/AdminDashboardRoutes";

const redirectRoute = [
  {
    path: "/agentTicket",  
        component: () => <Redirect to="/agentTicket/*" />
  },
  {
    path: "/agentUserChat",  
        component: () => <Redirect to="/agentUserChat/*" />
  }   
];

const errorRoute = [
  {
        component: () => <Redirect to="/agentlogin" />
  }
]; 
 
 

const routes = [  
  ...adminDashboardRoutes,
  ...adminUserChat,
  ...reportsRoute,
  ...adminLoginRoutes,  
  ...adminManagmentRoutes,
  ...userManagmentRoutes,
  ...adminDeptManagmentRoutes,
  ...adminBlockManagmentRoutes,  
  ...adminSettingsRoutes,
  ...adminChatRoutes,  
  ...inboxRoute,     
  ...redirectRoute,
  ...userTicketLoginRoutes,
  ...errorRoute
];

export default routes;
